import React, {forwardRef, useImperativeHandle, useState} from 'react';
import {Button, Modal} from "react-bootstrap";
import Loading from "../../components/loading";
import {Form, Formik} from "formik";
import {buildingStatSyncRequestSchema} from "../../utils/schemas";
import HelperService from "../../services/helper-service";
import Section from "../../components/section";
import {useGlobalNotificationMessage} from "../../context/message";
import Fileupload from "../../components/files/fileupload";
import Attachment from "../../components/files/attachment";
import {useBuildingStatService} from "../../services/building-stat-service";
import FormGroup from "../../components/form-group";
import {useBuildingService} from "../../services/building-service";

const BuildingStatsSyncModal = forwardRef( ({onSuccess=null, ...props}, ref) => {
  const [show, setShow] = useState(false);
  const [model, setModel] = useState();
  const [loading, setLoading] = useState(false);
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();
  const [files, setFiles] = useState([]);
  const [filesData, setFilesData] = useState([]);
  const [buildingsList, setBuildingsList] = useState([]);

  let formSchema = buildingStatSyncRequestSchema;

  let buildingStatService = useBuildingStatService();
  let buildingService = useBuildingService();

  //expose api for interacting with component
  useImperativeHandle(ref, () => ({
    openModal: openModal,
    closeModal: closeModal,
  }));

  const openModal = (model=null) => {
    setLoading(true);
    setFiles([]);

    let promises = [
     Promise.resolve('initOk'),
      buildingService.getList()
    ];

    Promise.all(promises).then(([init=null, buildings =[]])=>{
      setBuildingsList(buildings);

      setModel(formSchema.cast());
      setLoading(false);
    });

    setShow(true);
  }
  const closeModal = () => setShow(false);


  const onAttachmentDelete = (item)=>{
    setModel((model)=>{
      let m = model;
      m.attachments = [...HelperService.removeItemFromList(m.attachments, item)];
      return Object.assign({}, m);
    })
  };

  const onSubmit = (values, { setSubmitting, setErrors }) => {
    removeMessage();
    let reqValues = {...values};
    if (files && files.length){
      reqValues.files = files;
    }

    buildingStatService.syncBuildingStats(reqValues)
      .then((res) => {
        if (onSuccess && 'function' === typeof onSuccess){
          onSuccess(res);
        }
        setFiles([]);
        closeModal();
      })
      .catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage, "Nepodarilo sa uložiť zmeny.");
        HelperService.handleFormErrors(error, setErrors);
      })
      .finally(()=>{ setSubmitting(false);});
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={formSchema.cast(model) || formSchema.cast()}
        validationSchema={formSchema}
        onSubmit={onSubmit}
      >
        {({ isSubmitting, errors, touched, handleSubmit, setFieldValue, values}) => (

          <Modal size="lg" show={!!show} onHide={closeModal} centered>
            <Modal.Header closeButton>
              { model && <Modal.Title>Import dát pre budovy</Modal.Title>}
            </Modal.Header>
            <Modal.Body>
              <Section animation={HelperService.getRandomAnimation()}>

                {loading && <Loading className="m-2" />}

                {!loading && <Form className="row">

                  {/*<FormGroup*/}
                  {/*  name="description"*/}
                  {/*  placeholder="Poznámka"*/}
                  {/*  label="Poznámka"*/}
                  {/*  className="col-md-3"*/}
                  {/*  touched={touched} errors={errors} schema={formSchema}*/}
                  {/*/>*/}

                  <FormGroup
                    name="building_id"
                    type="select"
                    options={buildingsList}
                    optionLabel="title"
                    optionKey="id"
                    placeholder="typ"
                    label="Budova"
                    className="col-md-6"
                    required="required"
                    touched={touched} errors={errors} schema={formSchema}
                  />

                  <div className="col-sm-12">
                    <h5>Excel s dátami</h5>
                    <p className='text-muted'>Pridajte excelový dokument s vopred dohodnutým formátom.</p>
                    {model?.attachments && model?.attachments?.length>0 && <div className="row">
                      {model.attachments.map((att)=>{
                        return <div key={att.id} className="col-12"><Attachment attachment={att} onDelSuccess={(att)=>onAttachmentDelete(att)} /></div>;
                      })}
                    </div>}
                    <Fileupload files={files} filesData={filesData} onChange={({files, filesData})=>{setFiles(files); setFilesData(filesData)}} setFieldValue={setFieldValue} />
                  </div>

                  <div className="clearfix"></div>

                </Form>}

              </Section>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="outline-secondary" onClick={closeModal}>Zatvoriť</Button>
              <Button type="submit" variant="primary" onClick={handleSubmit} disabled={isSubmitting}>Odoslať</Button>
            </Modal.Footer>
          </Modal>
        )}
      </Formik>

    </>
  );
});

export default BuildingStatsSyncModal;
